(() => {
  function initialize() {
  const section = document.querySelector('[data-product-handle="rv003"][data-section-type="product"]');
  const notice = section?.querySelector('[data-kiwabi-purchase-notice]');
  const widget = section?.querySelector('.huckleberry-subscription-widget-container[data-widget-version="2"]');
  if (!section || !notice || !widget) return false;
  if (notice.dataset.initialized) return true;
  notice.dataset.initialized = 'true';
  let choice = null;
  let restoring = false;
  let queued = false;
  let attempts = 0;
  let generation = 0;
  const oneTimeNote = notice.querySelector('[data-kiwabi-onetime-note]');
  const subscriptionNote = notice.querySelector('[data-kiwabi-subscription-note]');
  const status = notice.querySelector('[data-kiwabi-selection-status]');
  const unsupported = notice.querySelector('[data-kiwabi-unsupported-plan]');
  const acceptOneTime = notice.querySelector('[data-kiwabi-accept-onetime]');
  let variants = [];
  try { variants = JSON.parse(notice.querySelector('[data-kiwabi-purchase-variants]')?.textContent || '[]'); } catch { return false; }
  const currentVariant = () => {
    const options = Array.from(section.querySelectorAll('[name^="options"]:checked, select[name^="options"]')).map(input => input.value);
    return variants.find(variant => variant.options.length === options.length && variant.options.every((value, index) => value === options[index]));
  };
  const form = section.querySelector('form[action*="/cart/add"]');
  const buttons = Array.from(section.querySelectorAll('[type="submit"]')).filter(button => !form || button.form === form);
  let busy = false;
  const radios = () => Array.from(widget.querySelectorAll('input[type="radio"]'));
  const currentMode = () => widget.querySelector('input[name="plan"]:checked')?.value || (currentVariant()?.planCount === 0 ? 'onetime' : undefined);
  const planName = input => input?.labels?.[0]?.querySelector('p')?.textContent.trim() || '';
  const selectedPlan = () => widget.querySelector('input[name="planOption"]:checked');
  const setBusy = value => { busy = value; };
  const show = (mode, pending = false) => {
    const unavailablePlan = choice?.mode === 'subscription' && currentVariant()?.planCount === 0;
    oneTimeNote.hidden = mode !== 'onetime' || unavailablePlan;
    subscriptionNote.hidden = mode === 'onetime' || unavailablePlan;
    status.hidden = !pending || unavailablePlan;
    if (unsupported) unsupported.hidden = !unavailablePlan;
  };
  const remember = input => {
    if (restoring || !input || !widget.contains(input)) return;
    if (input.name === 'plan') {
      if (choice?.mode === input.value) { queue(); return; }
      choice = { mode: input.value, id: null, name: null };
    } else if (input.name === 'planOption') {
      choice = { mode: 'subscription', id: input.value, name: planName(input) };
    } else return;
    attempts = 0;
    generation += 1;
    queue();
  };
  const targetPlan = () => radios().find(input => input.name === 'planOption' && input.value === choice?.id)
    || radios().find(input => input.name === 'planOption' && choice?.name && planName(input) === choice.name);
  const agrees = () => {
    if (!choice) return true;
    if (currentVariant()?.planCount === 0) {
      return choice.mode === 'onetime' && !widget.querySelector('input[name="plan"]');
    }
    if (currentMode() !== choice.mode) return false;
    return choice.mode !== 'subscription' || !choice.id || !!targetPlan()?.checked;
  };
  const settle = () => {
    queued = false;
    const mode = currentMode();
    if (!mode) return;
    if (!choice) {
      show(mode);
      return;
    }
    if (!agrees()) {
      setBusy(true);
      show(choice.mode, true);
      if (attempts >= 8) return;
      const target = mode !== choice.mode
        ? radios().find(input => input.name === 'plan' && input.value === choice.mode)
        : targetPlan();
      if (!target || target.disabled) return;
      attempts += 1;
      restoring = true;
      target.click();
      restoring = false;
      queue();
      return;
    }
    show(mode);
    const version = generation;
    requestAnimationFrame(() => requestAnimationFrame(() => {
      if (version === generation && agrees()) {
        show(currentMode());
        setBusy(false);
        attempts = 0;
      }
    }));
  };
  function queue() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(settle);
  }
  acceptOneTime?.addEventListener('click', () => {
    choice = { mode: 'onetime', id: null, name: null };
    generation += 1;
    attempts = 0;
    queue();
  });
  widget.addEventListener('click', event => {
    const target = event.target instanceof Element ? event.target : null;
    const label = target?.closest('label');
    const input = target?.matches('input[type="radio"]') ? target : label?.control;
    remember(input);
  }, true);
  widget.addEventListener('change', event => remember(event.target), true);
  section.addEventListener('change', event => {
    if (event.target instanceof Element && event.target.matches('[name^="options"]') && choice) {
      attempts = 0;
      generation += 1;
      setBusy(true);
      queue();
    }
  }, true);
  section.addEventListener('theme:variant:change', () => {
    if (choice) {
      attempts = 0;
      generation += 1;
      setBusy(true);
    }
    queue();
  });
  new MutationObserver(queue).observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked'] });
  section.addEventListener('click', event => {
    const button = event.target instanceof Element ? event.target.closest('[type="submit"]') : null;
    if (button && buttons.includes(button) && choice && (!agrees() || busy)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      show(choice.mode, true);
      queue();
    }
  }, true);
  form?.addEventListener('submit', event => {
    if (choice && (!agrees() || busy)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      show(choice.mode, true);
      queue();
    }
  }, true);
  window.addEventListener('pageshow', queue);
  queue();
  return true;
  }
  if (!initialize()) {
    const mountObserver = new MutationObserver(() => {
      if (initialize()) mountObserver.disconnect();
    });
    mountObserver.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(() => mountObserver.disconnect(), 10000);
    window.addEventListener('pagehide', () => mountObserver.disconnect(), { once: true });
  }
  document.addEventListener('shopify:section:load', initialize);
})();
